import { render } from "./SideBarRight.vue?vue&type=template&id=2206e892&scoped=true"
import script from "./SideBarRight.vue?vue&type=script&lang=js"
export * from "./SideBarRight.vue?vue&type=script&lang=js"

import "./SideBarRight.vue?vue&type=style&index=0&id=2206e892&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2206e892"]])

export default __exports__